module.exports = __webpack_public_path__ + "img/business-card-exchange.a0985da8.jpg";